import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Alerts = {
    success: (message) => {
        toast.success(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "bg-white",
            bodyClassName: "SystemMessage",
            icon: (
                <div className="flex items-center justify-center w-6 h-6 rounded-full bg-green-100 aspect-square">
                    <i className="fi fi-rs-check text-[10px] mt-1 text-green-500"></i>
                </div>
            ),
            style: {
                border: '0px solid #E8E8E8',
                borderLeft: '4px solid #22C55E',
            },
            progressStyle: {
                height: '2px'
            },
        });
    },

    warning: (message) => {
        toast.warning(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "bg-white",
            bodyClassName: "SystemMessage",
            icon: (
                <div className="flex items-center justify-center w-6 h-6 rounded-full bg-yellow-100 aspect-square">
                    <i className="fi fi-rs-exclamation text-[10px] mt-1 text-yellow-500"></i>
                </div>
            ),
            style: {
                border: '0px solid #E8E8E8',
                borderLeft: '4px solid #EAB308',
            },
            progressStyle: {
                height: '2px'
            },
        });
    },

    error: (message) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "bg-white",
            bodyClassName: "SystemMessage",
            icon: (
                <div className="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 aspect-square">
                    <i className="fi fi-rs-cross text-[10px] mt-1 text-red-500"></i>
                </div>
            ),
            style: {
                border: '0px solid #E8E8E8',
                borderLeft: '4px solid #EF4444',
            },
            progressStyle: {
                height: '2px'
            },
        });
    },
};

export default Alerts; 